<template>
  <div class="last-csat-notes">
    <woot-loading-state
      v-if="uiFlags.isFetching"
      :message="$t('CSAT.LOADING')"
    />
    <div v-if="!uiFlags.isFetching && notes.length" class="last-csat-notes__list">
      <div
        v-for="note in notes"
        :key="note.id"
        class="last-csat-notes__item"
      >
        <a :href="messageUrl(note)" target="_blank" class="last-csat-notes__date">#{{ formatDate(note.created_at) }}</a>
        <p class="last-csat-notes__line">
          <span class="last-csat-notes__label">
            {{ $t('LAST_CSAT_NOTES.RATING_LABEL') }}:
          </span>
          <span>{{ $t(`${ratingText(note.rating)}`) }}</span>
        </p>
        <p v-if="note.feedback_message" class="last-csat-notes__line">
          <span class="last-csat-notes__label">
            {{ $t('LAST_CSAT_NOTES.COMMENT_LABEL') }}:
          </span>
          <span>{{ note.feedback_message }}</span>
        </p>
      </div>
    </div>
    <div v-if="!uiFlags.isFetching && !notes.length" class="last-csat-notes__empty">
      {{ $t('LAST_CSAT_NOTES.EMPTY_STATE') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CSAT_RATINGS } from 'shared/constants/messages';
import timeMixin from 'dashboard/mixins/time';
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  mixins: [timeMixin],
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      csatResponses: 'csat/getCSATResponses',
      uiFlags: 'csat/getUIFlags',
    }),
    contactId() {
      return this.currentChat?.meta?.sender?.id;
    },
    notes() {
      const contactId = String(this.contactId || '');

      return (this.csatResponses || [])
        .filter(response => {
          const responseContactId = response?.contact?.id || response?.contact_id;
          return String(responseContactId || '') === contactId;
        })
        .slice(0, 5);
    },
  },
  watch: {
    contactId() {
      this.getCsatNotes();
    },
  },
  mounted() {
    this.getCsatNotes();
  },
  methods: {
    getCsatNotes() {
      if (!this.contactId) {
        return;
      }
      this.$store.dispatch('csat/get', {
        page: 1,
        contact_id: this.contactId,
      });
    },
    formatDate(value) {
      if (!value) {
        return '--';
      }

      return this.dateFormat(value, 'dd/MM/yyyy - HH:mm');
    },
    ratingText(value) {
      const selectedRating = CSAT_RATINGS.find(
        rating => rating.value === Number(value)
      );

      return selectedRating?.translationKey || '--';
    },
    messageUrl(note) {
      const messageId = note?.message_id;
      const conversationId = note?.conversation_id;

      if (messageId && conversationId) {
        const accountId = this.$route.params.accountId;
        return frontendURL(
          `accounts/${accountId}/conversations/${conversationId}?messageId=${messageId}`
        );
      }

      return '#';
    },
  },
};
</script>

<style lang="scss" scoped>
.last-csat-notes {
  &__list {
    max-height: 45rem;
    overflow-y: auto;
  }

  &__item {
    padding: var(--space-small) var(--space-normal);
    border-bottom: 1px solid var(--color-border);

    &:last-child {
      border-bottom: 0;
    }
  }

  &__date {
    color: #487CB8;
  }

  &__line {
    margin-bottom: var(--space-micro);
  }

  &__label {
    font-weight: var(--font-weight-medium);
  }

  &__empty {
    color: var(--b-500);
  }
}
</style>